"use strict";
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            TimeoutDialog_Body: "There was no activity for a while so we closed the session.",
            TimeoutDialog_Message: "Session ended",
            TimeoutDialog_ReconnectButtonText: "Start new session",
            TimeoutDialogWarning_Body: "If not, we'll close this session shortly in: ",
            TimeoutDialogWarning_Continue: "I'm here",
            TimeoutDialogWarning_Message: "Are you still there?",
            TimeoutDialogWarning_Signout: "Sign out",
        }
    });
    function showTimeoutDialog(dialogOptions) {
        var dialog = new $dyn.controls.TimeoutDialog(dialogOptions);
        var options = {
            context: dialog,
            role: "Dialog",
            templateId: "TimeoutDialog",
        };
        $dyn.shell.createForm(options);
        $dyn.shell.dialog(options);
    }
    $dyn.showTimeoutDialog = showTimeoutDialog;
    var controls;
    (function (controls) {
        /**
         * Framework base class for TimeoutDialog controls
         * @internal
         */
        var TimeoutDialog = /** @class */ (function () {
            function TimeoutDialog(dialogOptions) {
                var _this = this;
                this.continueButtonVisible = $dyn.observable(false);
                this.signoutButtonVisible = $dyn.observable(false);
                this.reconnectButtonVisible = $dyn.observable(false);
                this.timeRemaining = $dyn.observable();
                this.sessionExpiredWarning = -1;
                this.imageName = "Info";
                this.altText = $dyn.label("MessageBox_InfoIcon");
                if (dialogOptions.type === "Logout") {
                    this.continueButtonVisible(true);
                    this.signoutButtonVisible(true);
                    this.title = $dyn.label("TimeoutDialogWarning_Message");
                    this.message = $dyn.label("TimeoutDialogWarning_Body");
                    var intervalSeconds_1 = dialogOptions.timerCountDown;
                    this.sessionExpiredWarning = window.setInterval(function () {
                        intervalSeconds_1--;
                        var secondsToMinutes = "0" + Math.floor(intervalSeconds_1 / 60) + ":" + ("0" + Math.floor(intervalSeconds_1 % 60)).slice(-2);
                        _this.timeRemaining(secondsToMinutes);
                        if (intervalSeconds_1 === 0) {
                            window.clearInterval(_this.sessionExpiredWarning);
                        }
                    }, 1000);
                }
                else {
                    this.title = $dyn.label("TimeoutDialog_Message");
                    this.message = $dyn.label("TimeoutDialog_Body");
                    this.reconnectButtonVisible(true);
                }
            }
            TimeoutDialog.prototype.reconnect = function () {
                window.location.reload();
            };
            TimeoutDialog.prototype.continue = function () {
                // clear timeout if we have serverform
                if ($dyn.serverForm && $dyn.serverForm.sessionTimeoutRemainWarningShown) {
                    $dyn.serverForm.sessionTimeoutRemainWarningShown = false;
                    $dyn.serverForm.resetSessionTimeout();
                }
                // close dialog
                clearInterval(this.sessionExpiredWarning);
                $dyn.shell.dialogBack();
            };
            TimeoutDialog.prototype.logout = function () {
                $dyn.shell.logOut();
            };
            return TimeoutDialog;
        }());
        controls.TimeoutDialog = TimeoutDialog;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=TimeoutDialog.js.map
